import React from "react";
import {CarIcon, ForkliftIcon} from "assets/icons";
import {getLicenceKind, getLicenceTone} from "helper/licences";

// red-50/700, yellow-50/600 and green-50/700 of tailwind.config.js (its yellow scale is the orange one).
const TONE_STYLES = {
    red: {tile: "bg-red-50", color: "#B91C1C"},
    yellow: {tile: "bg-yellow-50", color: "#D77A1E"},
    green: {tile: "bg-green-50", color: "#047857"},
};

const LicenceIconTile = ({entry}) => {
    const {tile, color} = TONE_STYLES[getLicenceTone(entry)];
    const Icon = getLicenceKind(entry) === "caces" ? ForkliftIcon : CarIcon;
    return (
        <div className={`w-12 h-12 shrink-0 flex items-center justify-center rounded-lg ${tile}`}>
            <Icon wh={24} color={color}/>
        </div>
    );
};

export default LicenceIconTile;
